export enum CalendarCellHoverState {
  NO_HOVER_STATE = 'NO_HOVER_STATE',
  START_DATE = 'START_DATE',
  MIDDLE_DATE = 'MIDDLE_DATE',
  END_DATE = 'END_DATE',
  SINGLE_DATE = 'SINGLE_DATE',
}

export enum DateRangePlacement {
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
  IN_RANGE = 'IN_RANGE',
  NOT_IN_RANGE = 'NOT_IN_RANGE',
}

export enum CalendarCellBackdropStyle {
  RIGHT_BACKDROP = 'RIGHT_BACKDROP',
  LEFT_BACKDROP = 'LEFT_BACKDROP',
  NO_BACKDROP = 'NO_BACKDROP',
}
